module.exports = "<p>\n  status-report works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/status-report/status-report.component.html
// module id = ../../../../../src/app/status-report/status-report.component.html
// module chunks = main